var render = function () {
  var _vm$me, _vm$me2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "tile": ""
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("포인트내역")])]), _c('v-divider', {
    staticClass: "d-md-none"
  }), _c('div', {
    staticClass: "py-20px pt-md-0px pb-md-40px text-center"
  }, [_c('div', {
    staticClass: "tit tit--xs"
  }, [_c('b', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s((_vm$me = _vm.me) === null || _vm$me === void 0 ? void 0 : _vm$me.name))]), _vm._v("님의 포인트")]), _c('div', {
    staticClass: "mt-1"
  }, [_c('b', {
    staticClass: "tit tit--lg primary--text font-weight-bold"
  }, [_vm._v(_vm._s(parseInt(+((_vm$me2 = _vm.me) === null || _vm$me2 === void 0 ? void 0 : _vm$me2.point) || 0).format()))]), _vm._v(" 원")])]), _c('v-divider'), _c('div', [_c('v-data-table', {
    attrs: {
      "items": _vm.points,
      "headers": _vm.pointsHeaders,
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _c('span', {}, [_vm._v(_vm._s(parseInt(+item.amount || 0).format()) + "원")]);
      }
    }, {
      key: "item.remain",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('span', {}, [_vm._v(_vm._s(parseInt(+item.remain || 0).format()) + "원")]);
      }
    }])
  })], 1)], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }